export default [
  {
    path: "/unsubscribe/:unsubscribeToken",
    component: () => import("@/views/unsubscribe/Unsubscribe.vue"),
    meta: {
      hideNav: true,
      preventInit: true,
    },
  },
];
